import { withStyles } from "@material-ui/core"
import TextField from '@material-ui/core/TextField';

const CssTextField = withStyles({
    root: {
        // border: '1px solid #8080802b',
        boxShadow: '0px 2px 4px #00000029',
        borderRadius: '4px',
        padding: '5px',
        padding: '0px 11px 7px',
        lineHeight: '0.3',
        "& .MuiFormLabel-root": {
            color: "#808080b0",
            top: '-3px',
            left: '15px',
            fontSize: '14px'

        },
        "& .MuiSelect-icon": {
            top: '0px'

        },
        '& label.Mui-focused': {
            color: '#808080b0',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: 'green',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: 'red',
            },
            '&:hover fieldset': {
                borderColor: 'yellow',
            },
            '&.Mui-focused fieldset': {
                borderColor: 'green',
            },
        },
    },
})(TextField);


export default CssTextField